module.exports = __webpack_public_path__ + "static/media/heroBanner.b3cc1e4a.jpg";